import React from 'react';
const MainContext = React.createContext(null);
export default MainContext;